export enum CreateAppointmentMode {
  existing = 'existing',
  new = 'new',
}

export const NEW_EVENT_ID = 'new-event';
